const listeners = new Set();
let state = { items: [], loading: false, loaded: false, error: null };

export function getMemoryState() { return state; }
export function beginLoad() { state = { ...state, loading: true, error: null }; emit(); }
export function setItems(items) { state = { items: Array.isArray(items) ? items : [], loading: false, loaded: true, error: null }; emit(); }
export function setError(error) { state = { ...state, loading: false, loaded: true, error: error?.message || "记忆加载失败" }; emit(); }
export function subscribe(listener) { listeners.add(listener); listener(state); return () => listeners.delete(listener); }
function emit() { for (const listener of listeners) listener(state); }

export const memoryStore = Object.freeze({ getMemoryState, beginLoad, setItems, setError, subscribe });
